import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import Contact from "../components/pages/Contact";
import "../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer-futuristic">
      {/* <Contact /> */}
      <div className="cyber-grid"></div>
      <div className="container position-relative">
        <div className="row justify-content-center text-center">
          {/* Main Content Section */}
          <div className="col-12 col-md-8 mb-4">
            <h5 className="footer-title neon-text">
              <span className="flicker">Colee</span> Software Services
            </h5>
            <p className="footer-description">
              Empowering businesses with 
              <span className="highlight-pulse"> innovative software solutions</span>.
              <br />
              Contact us to learn how we can help your business
              <span className="neon-text-subtle"> grow and thrive</span>.
            </p>
          </div>

          {/* Social Icons Section */}
          <div className="col-12">
            <h5 className="footer-title neon-text">Connect With Us</h5>
            <div className="footer-social-icons">
              <a
                href="https://github.com/CorwinHiatt"
                className="social-link neon-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-github"></i>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61572314462403"
                className="social-link neon-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-facebook"></i>
              </a>
              <a
                href="https://x.com/ColeeSoftware"
                className="social-link neon-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-twitter-x"></i>
              </a>
              <a
                href="https://www.instagram.com/colee_software/"
                className="social-link neon-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-4">
          <p className="footer-copyright">
            <span className="neon-text-subtle">&copy; {new Date().getFullYear()}</span>
            <span className="highlight-pulse"> Colee Software Services</span>
            <span className="neon-text-subtle">. All rights reserved.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
//i need a commit 